/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SolarwaterHeatingConfigurationV0 } from './solarwaterHeatingConfigurationV0';
import { PVConfigurationV0 } from './pVConfigurationV0';


export interface RdSAPRenewablesRecoveryUIDTOV0 { 
    pvConfiguration?: PVConfigurationV0;
    /**
     * Indicates if the PV system is connected to the meter.
     */
    pvConnectedToMeter?: boolean;
    /**
     * The percentage of the roof area covered by the pvC system.
     */
    percentageOfRoofCovered?: number;
    /**
     * The pitch of the first PV array [DEPRECATED Put into an object in array].
     */
    array1Pitch?: string;
    /**
     * The orientation of the first PV array [DEPRECATED Put into an object in array].
     */
    array1Orientation?: string;
    /**
     * The amount of overshading affecting the first PV array [DEPRECATED Put into an object in array].
     */
    array1Overshading?: string;
    /**
     * The peak power of the first pvC array in kilowatts [DEPRECATED Put into an object in array].
     */
    array1KWP?: number;
    /**
     * Indicates if the first pvC array is connected to the meter [DEPRECATED Put into an object in array].
     */
    array1ConnectedToMeter?: boolean;
    /**
     * The pitch of the second pvC array [DEPRECATED Put into an object in array].
     */
    array2Pitch?: string;
    /**
     * The orientation of the second pvC array [DEPRECATED Put into an object in array].
     */
    array2Orientation?: string;
    /**
     * The amount of overshading affecting the second pvC array [DEPRECATED Put into an object in array].
     */
    array2Overshading?: string;
    /**
     * The peak power of the second pvC array in kilowatts [DEPRECATED Put into an object in array].
     */
    array2KWP?: number;
    /**
     * Indicates if the second pvC array is connected to the meter [DEPRECATED Put into an object in array].
     */
    array2ConnectedToMeter?: boolean;
    /**
     * The pitch of the third pvC array [DEPRECATED Put into an object in array].
     */
    array3Pitch?: string;
    /**
     * The orientation of the third pvC array [DEPRECATED Put into an object in array].
     */
    array3Orientation?: string;
    /**
     * The amount of overshading affecting the third pvC array [DEPRECATED Put into an object in array].
     */
    array3Overshading?: string;
    /**
     * The peak power of the third pvC array in kilowatts [DEPRECATED Put into an object in array].
     */
    array3KWP?: number;
    /**
     * Indicates if the third pvC array is connected to the meter [DEPRECATED Put into an object in array].
     */
    array3ConnectedToMeter?: boolean;
    swhConfiguration?: SolarwaterHeatingConfigurationV0;
    /**
     * Indicates if a solar water heating system is present. [TODO: Add a `solarWaterHeating` object]
     */
    solarWaterHeatingPresent?: boolean;
    /**
     * The pitch of the solar collector panel. [TODO: Add a `solarWaterHeating` object]
     */
    solarWaterHeaterPitch?: string;
    /**
     * The orientation of the solar collector panel. [TODO: Add a `solarWaterHeating` object]
     */
    solarWaterHeaterOrientation?: string;
    /**
     * The amount of overshading affecting the solar collector panel. [TODO: Add a `solarWaterHeating` object]
     */
    solarWaterHeaterOvershading?: string;
    /**
     * The types of showers associated with the solar water heating system. [TODO: Add a `solarWaterHeating` object]
     */
    solarWaterHeaterShowerTypes?: string;
    /**
     * The type of solar water circulating pump installed. [TODO: Add a `solarWaterHeating` object]
     */
    solarWaterHeaterCirculatingPump?: string;
    /**
     * The volume of the dedicated solar storage. [TODO: Add a `solarWaterHeating` object]
     */
    solarWaterHeaterDedicatedSolarVolume?: number;
    /**
     * The total volume of the hot water cylinder associated with the solar system. [TODO: Add a `solarWaterHeating` object]
     */
    solarWaterHeaterTotalCylenderVolume?: number;
    /**
     * The type of solar collector installed. [TODO: Add a `solarWaterHeating` object]
     */
    solarWaterHeaterCollectorType?: string;
    /**
     * The area of the solar collector panel. [TODO: Add a `solarWaterHeating` object]
     */
    solarWaterHeaterAreaOfPanel?: number;
    /**
     * The zero-loss efficiency of the solar collector. [TODO: Add a `solarWaterHeating` object]
     */
    solarWaterHeaterZeroLossEfficiency?: number;
    /**
     * The linear heat loss coefficient of the solar collector. [TODO: Add a `solarWaterHeating` object]
     */
    solarWaterHeaterLinearHeatLossCoefficient?: number;
    /**
     * The secondary heat loss coefficient of the solar collector. [TODO: Add a `solarWaterHeating` object]
     */
    solarWaterHeatersecoundaryHeatLossCoefficient?: number;
    /**
     * When True the total store volume, dedicated solar volume and combined cylinder are to be provided
     */
    solarWaterHeaterStoreVolumeDetailsKnown?: boolean;
    /**
     * The number of wind turbines present.
     */
    numberOfTurbines?: number;
    /**
     * The diameter of the rotor of the wind turbine.
     */
    rotorDiameter?: number;
    /**
     * The height of the hub of the wind turbine.
     */
    hubHeight?: number;
    /**
     * The index number for the Flue Gas heat Recovery System associated with main heating system 1.
     */
    fghrHeatingSystem1ID?: string;
    /**
     * The make of the FGHRS for main heating system 1.
     */
    fghrsHeatngSystem1Make?: string;
    /**
     * The model of the FGHRS for main heating system 1.
     */
    fghrsHeatngSystem1Model?: string;
    /**
     * The efficiency rating of the FGHRS for main heating system 1.
     */
    fghrsHeatngSystem1Efficiency?: string;
    /**
     * The index number for the Flue Gas heat Recovery System associated with main heating system 2.
     */
    fghrsHeatingSystem2ID?: string;
    /**
     * The make of the FGHRS for main heating system 2.
     */
    fghrsHeatngSystem2Make?: string;
    /**
     * The model of the FGHRS for main heating system 2.
     */
    fghrsHeatngSystem2Model?: string;
    /**
     * The efficiency rating of the FGHRS for main heating system 2.
     */
    fghrsHeatngSystem2Efficiency?: string;
    /**
     * The index number for the first Waste Water heat Recovery System.
     */
    wwhsrs1ID?: number;
    /**
     * The number of showers with system 1 that have a bath and are connected to the WWHRS.
     */
    wwhsrs1MixerShowersWithWWHRSAndBath?: number;
    /**
     * The number of showers with system 1 without a bath that are connected to the WWHRS.
     */
    wwhsrs1MixerShowersWithWWHRSNoBath?: number;
    /**
     * The index number for the second Waste Water heat Recovery System.
     */
    wwhsrs2ID?: number;
    /**
     * The number of showers with system 2 that have a bath and are connected to the WWHRS.
     */
    wwhsrs2MixerShowersWithWWHRSAndBath?: number;
    /**
     * The number of showers with system 2 without a bath that are connected to the WWHRS.
     */
    wwhsrs2MixerShowersWithWWHRSNoBath?: number;
    /**
     * The index number for the storage Waste Water heat Recovery System.
     */
    wwhsrstorageID?: number;
    /**
     * The make of the storage Waste Water heat Recovery System.
     */
    wwhsrstorageMake?: string;
    /**
     * The model of the storage Waste Water heat Recovery System.
     */
    wwhsrstorageModel?: string;
    /**
     * The efficiency rating of the storage Waste Water heat Recovery System.
     */
    wwhsrstorageEfficiency?: string;
    /**
     * The total number of showers and baths in the system that the storage WWHRS serves.
     */
    wwhsrstorageTotalShowersAndBaths?: number;
    /**
     * The number of showers and baths routed to the storage WWHRS.
     */
    wwhsrstorageShowersAndBathsToWWHRS?: number;
    /**
     * The volume of the storage associated with the WWHRS.
     */
    wwhsrstorageVolume?: number;
    /**
     * If combined cylinder the total hot water store volume is inclusive of the dedicated solar volume. 
     */
    combinedCylinder?: boolean;
    /**
     * Code which indicates the source of solar collector data. \'1\' - default, \'2\' - declared values
     */
    solarPanelCollectorDatasource?: RdSAPRenewablesRecoveryUIDTOV0.SolarPanelCollectorDatasourceEnum;
}
export namespace RdSAPRenewablesRecoveryUIDTOV0 {
    export type SolarPanelCollectorDatasourceEnum = '1' | '2';
    export const SolarPanelCollectorDatasourceEnum = {
        _1: '1' as SolarPanelCollectorDatasourceEnum,
        _2: '2' as SolarPanelCollectorDatasourceEnum
    };
}


